import React from 'react'
import { useTranslation } from 'react-i18next'

import { Message } from 'primereact/message'

export const NoPackagingMessage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="flex justify-content-center">
      <Message
        text={t('deliveryForecastDespatchAdvice.shippingDetails.message')}
      />
    </div>
  )
}
